import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from '@lingui/core';

export const PUBMED_SOURCE_ID = 5;
export const PUBMED_SOURCE_FEATURE_ID = 'pubmed_source_access';
export const SOURCE_ENTITLEMENT_ERROR_CODE = 'SOURCE_ENTITLEMENT_REQUIRED';

export type SourceAccessReason =
    | 'unrestricted'
    | 'subscription'
    | 'preview'
    | 'grandfathered_project'
    | 'denied'
    | 'source_inactive'
    | 'source_missing';

export interface SourceAccessDecision {
    sourceId: number;
    sourceName: string;
    isActive: boolean;
    allowed: boolean;
    featureId: string | null;
    reason: SourceAccessReason;
}

export function sourceAccessById(
    decisions: SourceAccessDecision[] | null | undefined
): Map<number, SourceAccessDecision> {
    return new Map((decisions || []).map((decision) => [decision.sourceId, decision]));
}

export function canAccessPubmed(
    decisions: SourceAccessDecision[] | null | undefined
): boolean {
    const decision = decisions?.find((value) => value.sourceId === PUBMED_SOURCE_ID);
    return decision?.isActive === true && decision.allowed === true;
}

export function isSourceEntitlementRequiredError(error: unknown): boolean {
    const candidate = error as { message?: unknown; details?: unknown; hint?: unknown } | null;
    return [candidate?.message, candidate?.details, candidate?.hint]
        .some((value) => typeof value === 'string' && (
            value.includes('SOURCE_ENTITLEMENT_REQUIRED')
        ));
}

export function sourceEntitlementMessage(): MessageDescriptor {
    return msg({
        id: 'sourceAccess.pubmedUpgradeRequired',
        message: 'PubMed is included in your one-time preview and every paid plan. Upgrade or reload your access before adding PubMed categories.',
    });
}
